import { useState, useRef, useEffect, useCallback } from 'react';

/**
 * 지정된 시간 동안 활동이 없으면 idle 상태로 전환하는 커스텀 훅입니다.
 * @param {number} timeout - 밀리초 단위의 타임아웃 시간.
 * @returns {{ isIdle: boolean; resetIdleTimer: () => void; forceIdle: () => void; }}
 */
export function useIdleTimer(timeout: number) {
  const [isIdle, setIsIdle] = useState(true);
  const idleTimerRef = useRef<NodeJS.Timeout | null>(null);

  const resetIdleTimer = useCallback(() => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }
    setIsIdle(false);
    idleTimerRef.current = setTimeout(() => {
      setIsIdle(true);
    }, timeout);
  }, [timeout]);

  const forceIdle = useCallback(() => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }
    setIsIdle(true);
  }, []);

  useEffect(() => {
    // 컴포넌트 언마운트 시 타이머 정리
    return () => {
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current);
      }
    };
  }, []);

  return { isIdle, resetIdleTimer, forceIdle };
}
